export default __webpack_public_path__ + "d20ec1b9e2f8600617395d04ec7da929.svg";